import { defineAsyncComponent } from 'vue'
export default {
  auth: defineAsyncComponent(() => import("/app/src/layouts/auth.vue").then(m => m.default || m)),
  dashboard: defineAsyncComponent(() => import("/app/src/layouts/dashboard.vue").then(m => m.default || m))
}